const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));

export { deepCopy };
